import {merge} from '../clone';
import isObject from './isObject';

/**
 * @private
 * Restores the one-level-depth object to the original object with nested properties.
 *
 * @param  {Array} names: list of keys in the object
 * @param  {any} value: the value of the object to transform
 * @return {Object}
 */
function restoreDepth(names, value) {
  const key = names.shift();
  // determines if the key is an array index
  const obj = (key === '0' || +key) ? [] : {};
  if (names.length) {
    // recursively iterates over properties/items
    obj[key] = restoreDepth(names, value);
  } else {
    obj[key] = value;
  }
  return obj;
}

/**
 * @public
 * Converts a one-level-depth object like `{info-one: value}`
 * to an object with nested properties like `{info: {one: value}}`.
 *
 * @see https://gist.github.com/jherax/18bccbf10f00a8565544
 *
 * @param  {Object} obj: Object to restore from `toOneLevelDepth`
 * @return {Object}
 */
export default function fromOneLevelDepth(obj) {
  let key, value, names;
  const newObj = {};
  if (!isObject(obj)) return obj;
  for (key in obj) {
    value = obj[key];
    names = key.split('-');
    merge(newObj, restoreDepth(names, value));
  }
  return newObj;
}
